import { PURCHASE_ORDER_AUDITS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/purchase_order_audits_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['purchaseOrderAuditsIndex']);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
